import React from 'react';

export default function HeadingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      height="16"
      width="16"
    >
      <g fill="#000" clipPath="url(#a)">
        <path
          fillRule="evenodd"
          d="M4.966 2.675c0-.179.075-.35.21-.477a.742.742 0 0 1 .508-.197h9.56a.76.76 0 0 1 .532.184c.07.063.127.139.166.223a.638.638 0 0 1-.166.756.76.76 0 0 1-.533.184H11.18v9.876a.657.657 0 0 1-.223.453.744.744 0 0 1-.494.185.743.743 0 0 1-.493-.185.658.658 0 0 1-.223-.453V3.347H5.683a.742.742 0 0 1-.506-.196.654.654 0 0 1-.211-.476Z"
          clipRule="evenodd"
        />
        <path d="M.212 7.094a.639.639 0 0 0-.21.469H0c0 .176.076.345.211.47a.753.753 0 0 0 .51.194h2.16v5.007c.01.17.09.33.223.446a.754.754 0 0 0 .496.182.754.754 0 0 0 .496-.182.643.643 0 0 0 .224-.446V8.227h2.16a.75.75 0 0 0 .491-.203.638.638 0 0 0 .201-.46.638.638 0 0 0-.201-.461.75.75 0 0 0-.492-.203H.721c-.191 0-.374.07-.509.194Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
